import React from "react";
import "../styles/global.css";
import "../styles/guides.css";
function Guides() {
	return (
		<div className="guides container">
			<div className="guides__header">
				<h4 className="guides__header__title">Trulia Guides</h4>
				<p className="guides__header__text">
					Everything you need to know when looking at homes or apartments for
					rent all in one place.
				</p>
				<button className="button guides__header__button">
					See all the guides
				</button>
			</div>
			<div className="guides__links-container">
				<div className="guide-link">
					<svg
						width="128"
						height="128"
						viewBox="0 0 128 128"
						xmlns="http://www.w3.org/2000/svg"
					>
						<g fill="none" fill-rule="evenodd">
							<path
								d="M27.05 27.25a3.905 3.905 0 0 1-5.498 0 3.904 3.904 0 0 1 0-5.497 3.903 3.903 0 0 1 5.498 0 3.904 3.904 0 0 1 0 5.497zm18.027 1.54L40.788 24.5l4.289-4.288h-.001a11.655 11.655 0 0 0 3.432-8.274c0-6.457-5.235-11.692-11.691-11.692a11.652 11.652 0 0 0-8.284 3.442l-4.278 4.278h-.001L19.975 3.69A11.653 11.653 0 0 0 11.692.247C5.235.247 0 5.482 0 11.94c0 3.231 1.312 6.157 3.432 8.273v.001l4.287 4.288-4.288 4.288h.001A11.653 11.653 0 0 0 0 37.065c0 6.456 5.235 11.69 11.692 11.69a11.65 11.65 0 0 0 8.283-3.442l4.278-4.277h.001l4.279 4.277a11.651 11.651 0 0 0 8.284 3.443c6.456 0 11.69-5.235 11.69-11.691 0-3.232-1.311-6.158-3.431-8.274z"
								fill="#FF5E3F"
								mask="url(#mask-2)"
								transform="translate(14.5 31.576)"
							></path>
							<path
								d="M24.253 0v14.558L12.12 7.278.003 14.522v33.985H48.51V0H24.253zm13.999 12.617h5.336V7.281h-5.336v5.336zm-5.338 12.12h5.336V19.4h-5.336v5.336z"
								fill="#144225"
								mask="url(#mask-4)"
								transform="translate(43.604 47.745)"
							></path>
							<path
								d="M24.508 13.392c0-.45-.056-.886-.158-1.304h.002l-.014-.053a.24.24 0 0 0-.003-.01l-1.322-5.203h-.003a4.056 4.056 0 0 0-3.959-3.182 4.057 4.057 0 0 0-3.96 3.182h-.003l-1.321 5.202-.003.01-.014.054h.002a5.459 5.459 0 0 0 3.965 6.596v5.57h2.668v-5.57a5.459 5.459 0 0 0 4.123-5.292zm-13.486-1.25a5.46 5.46 0 0 1-3.977 6.543v5.569H4.377v-5.57A5.459 5.459 0 0 1 .4 12.141H.394l1.409-8.78h.005A3.95 3.95 0 0 1 5.712.001a3.95 3.95 0 0 1 3.903 3.36h.006l1.413 8.78h-.012z"
								fill="#C2D500"
								mask="url(#mask-6)"
								transform="translate(86.938 71.999)"
							></path>
						</g>
					</svg>
					<div className="guide-link__content">
						<h4>Renter Guides</h4>
						<p>
							How to rent
							<span>
								<svg
									class="svg"
									viewBox="0 0 32 32"
									xmlns="http://www.w3.org/2000/svg"
									width="24px"
								>
									<path
										d="M22.756 14.71l-5.11-5.775 1.993-1.762 7.725 8.73-7.693 9.005-2.022-1.728 4.963-5.81H5.56v-2.66h17.195z"
										fill="#007882"
									></path>
								</svg>
							</span>
						</p>
					</div>
				</div>
				<div className="guide-link">
					<svg
						width="128"
						height="128"
						viewBox="0 0 128 128"
						xmlns="http://www.w3.org/2000/svg"
					>
						<g fill="none" fill-rule="evenodd">
							<path
								fill="#CEB6FF"
								d="M85.166 30v15.546l-7.767-13.463-5.02 2.9 7.767 13.464-13.453-7.773-2.899 5.025 13.453 7.773H61.713v5.802h15.534l-13.453 7.773 2.899 5.024 13.453-7.773-7.767 13.464 5.02 2.901 7.767-13.464v15.546h5.797V67.2l7.766 13.464 5.021-2.901-7.767-13.464 13.453 7.773 2.899-5.024-13.452-7.773h15.532v-5.802H98.883l13.452-7.773-2.9-5.025-13.452 7.773 7.767-13.463-5.02-2.901-7.767 13.463V30z"
							></path>
							<path
								d="M67.223 39.73L43.145 61.423v26.502H91.3V61.423L67.223 39.73zm-14.71 38.559h5.341v-9.64h-5.342v9.64z"
								fill="#052286"
							></path>
							<path
								d="M37.622 80.716h-4.027c-.82 2.263-2.982 3.888-5.523 3.888-2.54 0-4.703-1.625-5.522-3.888h-4.028c-.82 2.263-2.982 3.888-5.522 3.888v3.318a9.184 9.184 0 0 0 7.536-3.942 9.185 9.185 0 0 0 7.536 3.942 9.184 9.184 0 0 0 7.536-3.942 9.185 9.185 0 0 0 7.537 3.942v-3.318c-2.54 0-4.703-1.625-5.523-3.888m0 9.971h-4.027c-.82 2.264-2.982 3.888-5.523 3.888-2.54 0-4.703-1.624-5.522-3.888h-4.028c-.82 2.264-2.982 3.888-5.522 3.888v3.319a9.184 9.184 0 0 0 7.536-3.942 9.185 9.185 0 0 0 7.536 3.942 9.184 9.184 0 0 0 7.536-3.942 9.185 9.185 0 0 0 7.537 3.942v-3.319c-2.54 0-4.703-1.624-5.523-3.888m0-19.943c.82 2.263 2.983 3.888 5.523 3.888v3.318a9.185 9.185 0 0 1-7.537-3.941 9.185 9.185 0 0 1-7.536 3.941 9.185 9.185 0 0 1-7.536-3.941A9.185 9.185 0 0 1 13 77.95v-3.318c2.54 0 4.703-1.625 5.522-3.888h4.028c.82 2.263 2.982 3.888 5.522 3.888s4.703-1.625 5.523-3.888h4.027"
								fill="#00ADBB"
							></path>
						</g>
					</svg>
					<div className="guide-link__content">
						<h4>Buyer Guides</h4>
						<p>
							How to rent
							<span>
								<svg
									class="svg"
									viewBox="0 0 32 32"
									xmlns="http://www.w3.org/2000/svg"
									width="24px"
								>
									<path
										d="M22.756 14.71l-5.11-5.775 1.993-1.762 7.725 8.73-7.693 9.005-2.022-1.728 4.963-5.81H5.56v-2.66h17.195z"
										fill="#007882"
									></path>
								</svg>
							</span>
						</p>
					</div>
				</div>
				<div className="guide-link">
					<svg
						width="128"
						height="128"
						viewBox="0 0 128 128"
						xmlns="http://www.w3.org/2000/svg"
					>
						<g fill="none" fill-rule="evenodd">
							<path
								d="M7.987 24.113l1.017-.303.234-1.052c.632-2.834 3.068-4.814 5.924-4.814 3.35 0 6.076 2.778 6.076 6.193v1.836h1.802c2.387 0 4.37 1.775 4.758 4.097h3.637c-.357-3.787-3.133-6.865-6.732-7.602-.78-4.648-4.762-8.197-9.541-8.197-4.204 0-7.837 2.694-9.16 6.667-3.57 1.507-5.986 5.119-5.986 9.118H3.62c0-2.733 1.796-5.176 4.367-5.943m24.784-4.856h-3.604c0-2.49-1.987-4.515-4.43-4.515h-1.802v-1.836c0-1.992-1.309-3.773-3.183-4.332l-1.017-.304-.235-1.052c-.46-2.066-2.236-3.509-4.318-3.509-2.442 0-4.43 2.025-4.43 4.515v1.836H7.95c-1.9 0-3.445 1.575-3.445 3.511H.902c0-3.386 2.31-6.232 5.408-6.987.748-3.732 3.993-6.547 7.872-6.547 3.43 0 6.404 2.162 7.545 5.37 2.377 1.065 4.11 3.262 4.642 5.832 3.65.77 6.402 4.073 6.402 8.018"
								fill="#CEB7FF"
								mask="url(#mask-2)"
								transform="translate(76.505 49.398)"
							></path>
							<path
								d="M26.165 26.664a4.566 4.566 0 0 1-6.493 0c-1.782-1.807-1.782-4.776 0-6.583a4.566 4.566 0 0 1 6.493 0c1.783 1.807 1.783 4.776 0 6.583m19.67-3.299C45.835 10.532 35.575.13 22.918.13 10.26.13 0 10.532 0 23.365A23.327 23.327 0 0 0 5.81 38.82h-.005l17.113 19.402L40.032 38.82h-.007a23.327 23.327 0 0 0 5.81-15.455"
								fill="#740631"
								mask="url(#mask-4)"
								transform="translate(18.111 35)"
							></path>
							<path
								fill="#FF5E3F"
								d="M59.448 58.56l-8.531 8.672v26.013h6.653v-8.667h3.753v8.667h13.254v-8.667h3.753v8.667h6.705v-17.37l-8.522-8.646L67.97 75.9v-8.669z"
							></path>
						</g>
					</svg>
					<div className="guide-link__content">
						<h4>Seller Guides</h4>
						<p>
							How to rent
							<span>
								<svg
									class="svg"
									viewBox="0 0 32 32"
									xmlns="http://www.w3.org/2000/svg"
									width="24px"
								>
									<path
										d="M22.756 14.71l-5.11-5.775 1.993-1.762 7.725 8.73-7.693 9.005-2.022-1.728 4.963-5.81H5.56v-2.66h17.195z"
										fill="#007882"
									></path>
								</svg>
							</span>
						</p>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Guides;
